import { render, staticRenderFns } from "./HistogramPopup.vue?vue&type=template&id=fb7e7f66&scoped=true&"
import script from "./HistogramPopup.vue?vue&type=script&lang=js&"
export * from "./HistogramPopup.vue?vue&type=script&lang=js&"
import style0 from "./HistogramPopup.vue?vue&type=style&index=0&id=fb7e7f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7e7f66",
  null
  
)

/* custom blocks */
import block0 from "./HistogramPopup.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb7e7f66')) {
      api.createRecord('fb7e7f66', component.options)
    } else {
      api.reload('fb7e7f66', component.options)
    }
    module.hot.accept("./HistogramPopup.vue?vue&type=template&id=fb7e7f66&scoped=true&", function () {
      api.rerender('fb7e7f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/PlaceFloorPlans/HistogramPopup.vue"
export default component.exports